import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { buscarMeusEventos } from '@/api/conta';
import { useRequisicao } from '@/hooks/useRequisicao';
import { formatarDataHora, formatarMoeda } from '@/lib/formato';

import {
  Carregando,
  Cartao,
  ErroCarregamento,
  EstadoVazio,
  Secao,
  Status,
} from './ContaUI';

export default function MeusEventos() {
  const buscar = useCallback(buscarMeusEventos, []);
  const { dados, carregando, erro, recarregar } = useRequisicao(buscar);

  if (carregando) {
    return (
      <Secao titulo="Meus eventos">
        <Carregando />
      </Secao>
    );
  }

  if (erro) {
    return (
      <Secao titulo="Meus eventos">
        <ErroCarregamento onTentarNovamente={recarregar} />
      </Secao>
    );
  }

  const inscricoes = dados ?? [];

  return (
    <Secao
      titulo="Meus eventos"
      descricao={
        inscricoes.length
          ? `${inscricoes.length} inscrição(ões) no seu histórico`
          : undefined
      }
    >
      {inscricoes.length === 0 ? (
        <EstadoVazio
          titulo="Você ainda não tem inscrições"
          descricao="Quando se inscrever em um encontro, ele aparece aqui com data, local e status do pagamento."
          acao={
            <Link
              to="/"
              className="bg-wine hover:bg-wine-deep rounded-full px-5 py-2.5 text-xs font-bold tracking-[0.14em] text-white uppercase transition-colors"
            >
              Ver encontros
            </Link>
          }
        />
      ) : (
        <ul className="space-y-3">
          {inscricoes.map((inscricao) => {
            const evento = inscricao.eventDay?.event;
            return (
              <li key={inscricao.id}>
                <Cartao>
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <h3 className="text-ink font-medium">
                        {evento?.title ?? 'Encontro'}
                      </h3>
                      <p className="text-ink-soft/70 mt-1 text-sm">
                        {formatarDataHora(inscricao.eventDay?.startDate)}
                        {evento?.location ? ` · ${evento.location}` : ''}
                      </p>
                      <p className="text-ink-soft/50 mt-2 text-xs">
                        {formatarMoeda(inscricao.amountPaid)} · inscrição feita
                        em {formatarDataHora(inscricao.createdAt)}
                      </p>
                    </div>
                    <Status valor={inscricao.status} />
                  </div>
                </Cartao>
              </li>
            );
          })}
        </ul>
      )}
    </Secao>
  );
}
